import coordData from "./coord-data";


const plans:any = {

    '0105': [105],
    '0106': [106],
    '0107': [107],
    '0108': [108],
    '0109': [109],
    '0110': [110],
    '0111': [111],
    '0112': [112],
    '0113': [113],
    '0114': [114],
    '0115': [115],
    '0116': [116],
    '0117': [117],
    '0118': [118],
    '0119': [119],
    '0120': [120],
    '0205_0311_0411': [205, 311, 411],
    '0206_0312': [206, 312],
    '0207_0313': [207, 313],
    '0208': [208],
    '0209': [209],
    '0210': [210],
    '0211_0317_0417': [211, 317, 417],
    '0212_0318_0418': [212, 318, 418],
    '0213_0319_0419': [213, 319, 419],
    '0214': [214],
    '0215_0321': [215, 321],
    '0216_0322': [21, 322],
    '0217_0323': [217, 323],
    '0218_0324': [218, 324],
    '0219_0325_0425': [219, 325, 425],
    '0220_0326': [220, 326],
    '0221_0327': [221, 327],
    '0314': [314],
    '0315_0415': [315, 415],
    '0316': [316],
    '0320': [320],
    '0412': [412],
    '0413': [413],
    '0414': [414],
    '0416': [416],
    '0420': [420],
    '0421': [421],
    '0422': [422],
    '0423': [423],
    '0424': [424],
    '0426': [426],
    '0427': [427],
    '0519_0619_0719_0818_0918_1011_1109_1209_1309_1409_1509_1609': [519, 619, 719, 818, 918, 1011, 1109, 1209, 1309, 1409, 1509, 1609],
    '0520_0620_0720_0819_0919_1012_1110': [520, 620, 720, 819, 919, 1012, 1110],
    '0521_0621_0721_0820_0920_1013_1111': [521, 621, 721, 820, 920, 1013, 1111],
    '0522_0622_0722_0821_0921_1014_1112_1212_1312_1412_1512_1612': [522, 622, 722, 821, 921, 1014, 1112, 1212, 1312, 1412, 1512, 1612],
    '0523_0623_0723_0822_0922_1015_1113_1213_1313_1413_1513_1613': [523, 623, 723, 822, 922, 1015, 1113, 1213, 1313, 1413, 1513, 1613],
    '0524_0624_0724_0823_0923_1016_1114_1214_1314_1414_1514_1614': [524, 624, 724, 823, 923, 1016, 1114, 1214, 1314, 1414, 1514, 1614],
    '0525_0625_0725_0824_0924_1017_1115_1215_1315_1415_1515_1615': [525, 625, 725, 824, 924, 1017, 1115, 1215, 1315, 1415, 1515, 1615],
    '0526_0626_0726_0825_0925_1018_1116': [526, 626, 726, 825, 925, 1018, 1116],
    '0527_0627_0727_0826_0926_1019': [527, 627, 727, 826, 926, 1019],
    '0528_0628_0728_0827_0927_1020': [528, 628, 728, 827, 927, 1020],
    '0529_0629_0729_0828_0928_1021': [529, 629, 729, 828, 928, 1021],
    '0530_0630_0730_0829_0929_1022': [530, 630, 730, 829, 929, 1022],
    '0531_0631_0731_0830_0930_1023': [531, 631, 731, 830, 930, 1023],
    '0532_0632_0732_0831_0931_1024': [532, 632, 732, 831, 931, 1024],
    '0533_0633_0733_0832_0932_1025': [533, 633, 733, 832, 932, 1025],
    '1117': [1117],
    '1118': [1118],
    '1210_1310_1410_1510_1610': [1210, 1310, 1410, 1510, 1610],
    '1211_1311_1411_1511_1611': [1211, 1311, 1411, 1511, 1611],
    '1216_1316_1416_1516_1616': [1216, 1316, 1416, 1516, 1616],
    '1706': [1706],
    '1707_1807': [1707, 1807],
    '1708_1808': [1708, 1808],
    '1709_1809': [1709, 1809],
    '1710_1810': [1710, 1810],
    '1806': [1806],


}


function getPlan(apartmentId:string){
    var planKeys = Object.keys(plans);
    for(var k=0; k < planKeys.length; k++){
        var plan:any = planKeys[k];
        var apartments:number[] = plans[plan];
        var id = parseInt(apartmentId);
        if(apartments.indexOf(id) != -1){
            return plan;
        }
    }
    return null;
}


function getPDF(planId:string|null){
    if(planId == '4444'
    || planId == '4445'
    || planId == '4446'){
        return `SEK25321_Lumia_FloorplanTemplate_Penthouse_V7_FA_LR_${planId}.pdf`
    }else if(planId && planId.indexOf("P")==0){
        return `SEK25321_Lumia_FloorplanTemplate_Standard_V8_FA_LR_${planId}.pdf`
    }else{
        return planId + ".pdf";
    }
}


export default {
    getPlan,
    getPDF
}